import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { Link as RouterLink, matchPath, useLocation } from 'react-router-dom';
import { useActiveClassroom, useActiveSimulation } from '../active-simulation/useActiveSimulation';
import BottomPanel from '../bottom-panel/BottomPanel';
import { Pages } from '../types/pages';
import { isInstructorClassroom, isRunning } from '../utils/activeSimulation';

const ReturnToClassroom = () => {
  const { activeClassroom } = useActiveClassroom();
  const { activeSimulation } = useActiveSimulation();
  const { pathname } = useLocation();

  const matchesPage = (path: string, id?: string) => {
    const matches = matchPath(path, pathname);
    return matches?.params.id === id;
  };

  if (
    !isRunning(activeSimulation) &&
    isInstructorClassroom(activeClassroom) &&
    !matchesPage('/teach/exercises/:id', activeClassroom.exercise.id) &&
    !matchesPage(`/teach/exercises/:id/${Pages.Classroom}`, activeClassroom.exercise.id)
  ) {
    return (
      <BottomPanel sx={{ minHeight: { xs: 111, sm: 65 } }}>
        <Box display={{ sm: 'flex' }} alignItems="center" justifyContent="space-between" gap={3}>
          <Typography variant="body2" sx={{ lineHeight: 1 }}>
            You are hosting a team session.
          </Typography>

          <Box mt={{ xs: 4, sm: 0 }}>
            <Button
              component={RouterLink}
              to={`teach/exercises/${activeClassroom.exercise.id}/${Pages.Classroom}`}
              variant="contained"
            >
              Return to team session
            </Button>
          </Box>
        </Box>
      </BottomPanel>
    );
  }

  return null;
};

export default ReturnToClassroom;
